var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4441_42271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.475 13.0625C12.2418 13.0625 11.6488 13.75 9.625 13.75C7.60117 13.75 7.0125 13.0625 5.775 13.0625C2.58672 13.0625 0 15.6492 0 18.8375V19.9375C0 21.0762 0.923828 22 2.0625 22H17.1875C18.3262 22 19.25 21.0762 19.25 19.9375V18.8375C19.25 15.6492 16.6633 13.0625 13.475 13.0625ZM17.1875 19.9375H2.0625V18.8375C2.0625 16.7922 3.72969 15.125 5.775 15.125C6.40234 15.125 7.4207 15.8125 9.625 15.8125C11.8465 15.8125 12.8434 15.125 13.475 15.125C15.5203 15.125 17.1875 16.7922 17.1875 18.8375V19.9375ZM9.625 12.375C13.041 12.375 15.8125 9.60352 15.8125 6.1875C15.8125 2.77148 13.041 0 9.625 0C6.20898 0 3.4375 2.77148 3.4375 6.1875C3.4375 9.60352 6.20898 12.375 9.625 12.375ZM9.625 2.0625C11.898 2.0625 13.75 3.91445 13.75 6.1875C13.75 8.46055 11.898 10.3125 9.625 10.3125C7.35195 10.3125 5.5 8.46055 5.5 6.1875C5.5 3.91445 7.35195 2.0625 9.625 2.0625Z",
    fill: "#9F9F9F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4441_42271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.25,
    height: 19.25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/User-icon.9250ef2d17aefc0c1e529ebf617e7b05.svg";
export { ForwardRef as ReactComponent };